import { render, staticRenderFns } from "./OnlineDraw.vue?vue&type=template&id=3af8c9c6&scoped=true&"
import script from "./OnlineDraw.vue?vue&type=script&lang=js&"
export * from "./OnlineDraw.vue?vue&type=script&lang=js&"
import style0 from "./OnlineDraw.vue?vue&type=style&index=0&id=3af8c9c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af8c9c6",
  null
  
)

export default component.exports